import React from "react";
import BaseModel from "../models/BaseModel";
import TreeViewModel from "../models/TreeviewModel";
import Page from "../models/Page";
import BaseModelMap from "../models/BaseModelMap";
import Logger from "../Logger";
import TreeMenuIcon from "../components/NavigationTree2/TreeMenuIcon";
import Scene from "../models/Scene";
import Multiplexer from "../models/Multiplexer";
import { noItx } from "../translationItx/itx";

const logger = new Logger();

export default class SceneGroupTreeViewModel extends TreeViewModel {
  page?: Page;

  get typedObj(): BaseModelMap<BaseModel> {
    return this.obj as BaseModelMap<BaseModel>;
  }

  get isFolder(): boolean {
    return true;
  }

  getTagNeeded(): boolean {
    return false;
  }

  getDisableEdit(): boolean {
    return true;
  }
  get childCollection(): Array<BaseModel> | undefined {
    const res = new Array<BaseModel>();
    const res2 = new Array<BaseModel>();
    this.typedObj.sortIntBy("sceneNumber").forEach((obj) => {
      switch (obj.className) {
        case noItx("Scene"): {
          // no itx
          res.push(obj);
          break;
        }
      }
    });

    this.typedObj.sortBy("name").forEach((obj) => {
      switch (obj.className) {
        case "Multiplexer": {
          // no itx
          res2.push(obj);
          break;
        }
      }
    });

    return res.concat(res2);
  }

  // handleOpen(): boolean {
  //   let sceneListInPG = false;

  //   state.pageGroups.forEach((pg) => {
  //     pg.pages.forEach((p) => {
  //       if (p.documentType.type == PageTypes.scenelist) {
  //         sceneListInPG = true;
  //         this.page = p;
  //       }
  //     });
  //   });

  //   if (!sceneListInPG) {
  //     const parentPageGroup = state.pageGroups.getByPropertyValue("tag", "01");
  //     this.page = new Page({ tag: "SZ", name: itx(`pageDocumentType.Szenenliste`,"Szenenliste" )}, parentPageGroup);

  //     this.page.documentType = {
  //       type: PageTypes.scenelist,
  //       name: state.translate(`pageDocumentType.Szenenliste`, "Szenenliste"),
  //     };
  //     this.page.clearDirty();
  //     state.pageGroups.forEach((pg) => {
  //       if (pg.tag == "01" && this.page) {
  //         pg.pages.add(this.page);
  //       }
  //     });
  //   }

  //   if (this.page) {
  //     const pageId = this.page.id;

  //     if (state.activePanes.isOpen(pageId)) {
  //       state.activePanes.activatePane(pageId);
  //     } else {
  //       state.activePanes.loadPage(pageId);
  //     }
  //   }
  //   return true;
  // }

  ////////////////////////////////////////////////////////////////////////////////////////
  //
  // inline menu buttons
  //
  //super.inlineButton_Properties(),
  ////////////////////////////////////////////////////////////////////////////////////////

  getButtons(): JSX.Element[] | undefined {
    return [this.inlineButton_Add()];
  }

  ////////////////////////////////////////////////////////////////////////////////////////
  //
  // context menu
  //
  ////////////////////////////////////////////////////////////////////////////////////////

  createItem(className: "Scene" | "Multiplexer"): void {
    let sceneNumber = 1;
    let newName = `${state.translate(`components.${className}`, className)}`;
    state.sceneGroup.forEach((scene) => {
      if (className == "Scene" && scene.className == "Scene") {
        sceneNumber = Math.max(sceneNumber, scene.sceneNumber) + 1;
      } else if (className == "Multiplexer" && scene.className == "Multiplexer") {
        sceneNumber++;
      }
    });
    newName = newName + ` ${sceneNumber}`;
    const newNumber = `${sceneNumber}`;
    const sceneOrMultiplexer =
      className == "Scene"
        ? new Scene({ name: newName, sceneNumber: newNumber }, state.sceneGroup)
        : new Multiplexer({ name: newName }, state.sceneGroup);
    if (className == "Multiplexer") {
      sceneOrMultiplexer.generateTagFromName();
      sceneOrMultiplexer.generateNewNameFromTag();
    }
    state.sceneGroup.add(sceneOrMultiplexer);
    state.sceneGroup.raiseOnChange();
    state.selectionManager.selectedObject = sceneOrMultiplexer;
  }

  buildAddSceneMenuItems(): any {
    const imageStyle: any = { width: "auto", height: "25px", objectFit: "contain" };
    const rawItems = [
      {
        image: "/images/various/scene.png",
        text: state.translate("ContextMenuLables.addScene", "Szene erzeugen"),
        onClick: () => {
          this.createItem("Scene"); // no itx
        }, // no itx
      },
      {
        image: "/images/various/multiplexer.png",
        text: state.translate("ContextMenuLables.addMultiplexer", "Multiplexer erzeugen"),
        onClick: () => {
          this.createItem("Multiplexer");
        }, // no itx
      },
    ];

    return {
      title: state.translate("treeViewModel.connect", "Hinzufügen"),
      items: rawItems.map((item, i) => ({
        id: `item_Scene_${i}`,
        image: <img draggable="false" style={imageStyle} src={item.image} />, // no itx
        label: item.text,
        onClick: item.onClick,
      })),
    };
  }

  inlineButton_Add() {
    return (
      <TreeMenuIcon
        onClick={(ev: any) => {
          this.handleAddSceneOrMultiplex(ev);
        }}
        iconName="plus-circle"
        tooltipKey="inlineButton.addSceneOrMultiplexer" // no itx
        objName={this.obj.className + this.obj.fullTag}
        key={this.obj.className + this.obj.fullTag + "autoConnect"} // no itx
      />
    );
  }

  handleAddWithEvent(event: any) {
    this.handleAddSceneOrMultiplex(event);
  }

  handleAddSceneOrMultiplex(ev: any) {
    state.contextMenuManager.show1(ev, this.buildAddSceneMenuItems(), []);
  }

  getButtonsAsContextMenuItems(): any[] {
    return this.buttonsAsContextMenuItems().map((item) => {
      if (item.id === "btn_plus-circle") {
        return { ...item, menu: this.buildAddSceneMenuItems(), onClick: undefined };
      }
      return item;
    });
  }

  ////////////////////////////////////////////////////////////////////////////////////////
  canBePastedInteractive(copiedObjClassName: string): boolean {
    if (copiedObjClassName == "Scene") {
      return true;
    }
    return false;
  }

  async getDisabledContextMenuItems(): Promise<Array<string>> {
    const copiedObjClassName = state.clipboard.getClassName();

    if (copiedObjClassName && copiedObjClassName == "Scene") {
      return new Array<string>();
    }
    return ["paste"]; // no itx
  }

  get contextMenuItems(): any {
    var subLabelPaste = undefined;

    try {
      subLabelPaste = state.contextMenuManager.clipboardData.items[0].name;
    } catch (ex) {
      logger.error(ex);
    }

    return {
      title: this.obj?.name,
      items: [
        // this.baseContextMenuItems_Copy(),
        // this.baseContextMenuItems_Cut(),
        this.baseContextMenuItems_Paste(subLabelPaste),
        this.baseContextMenuItems_Delete(),
        this.inlineButton_Add(),
        // this.baseContextMenuItems_Properties(),
      ],
    };
  }
}
